export class ModalFluxoAprovacoesService {
    static $inject = [
        '$uibModal'
    ];

    constructor(
        private $uibModal: ng.ui.bootstrap.IModalService,
    ) { }

    public open(objEquipe: any): angular.ui.bootstrap.IModalInstanceService {
        return this.$uibModal.open({
            template: require('html-loader!./fluxoaprovacoes.modal.html'),
            controller: 'ModalFluxoAprovacoesController',
            controllerAs: '$ctrl',
            backdrop: 'static',
            resolve: {
                entity: () => objEquipe
            }
        });
    }
}
